export class QueryCommandItem {
  public id: string;
  public name: string;
  public nodeType: string;
  public tooltip: string;
  public idNum: number;
  public alias: string;
  public title: string;
  public text: string;
  public label: string;
  public image: string;
  public icon: string;
  public buttonClass: string;
  public description?: string;
  public labelLine: any;
  public prefix?: string;
  public resultName?: string;
  public isNotifyOnQuerySuccess: boolean;
  public actionToDispatchOnQuerySuccess: any;
}
